import { render, staticRenderFns } from "./talk-navbar.vue?vue&type=template&id=0f5469ac&scoped=true"
import script from "./talk-navbar.vue?vue&type=script&lang=js"
export * from "./talk-navbar.vue?vue&type=script&lang=js"
import style0 from "./talk-navbar.vue?vue&type=style&index=0&id=0f5469ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5469ac",
  null
  
)

export default component.exports